<template>
  <div>
    <div class="ask-export">
      <!-- 专家详情 -->
      <div class="export-info">
        <!-- 专家图片 -->
        <div class="export-info-img">
          <img :src="exportInfo.userAvatarUrl || BASE_URL + 'img/zwt.png'" :alt="exportInfo.name"/>
        </div>
        <!-- 专家信息 -->
        <div class="export-info-detail">
          <div class="export-info-detail-name">{{exportInfo.name}}</div>
          <!-- 专家标签 -->
          <div class="export-info-detail-category" v-if="exportInfo&&exportInfo.fileVideoTypeAttributeEntityList&&exportInfo.fileVideoTypeAttributeEntityList.length">
            <span v-for="item in exportInfo.fileVideoTypeAttributeEntityList" :key="item.id">{{item.typeAttributeValue}}</span>
          </div>
          <div class="export-info-detail-introduction" :style="moreDetailStyle">
            <p :title="exportInfo.expertIntroduction">{{exportInfo.expertIntroduction}}</p>
          </div>
          <div class="xkfkmore" @click="showMoreDetailHandle" v-if="exportInfo.expertIntroduction&&exportInfo.expertIntroduction.length>137">{{showMoreDetail ? '展开更多' : '收起更多'}}</div>
          <div class="export-info-opt">
            <div class="export-info-opt-but" @click="routerHandleAskExport(exportInfo.id)">我要提问</div>
            <div class="export-info-opt-label">
              <div class="export-about-info">
                <div class="export-about-info-count">{{exportInfo.questionCount||0}}</div>
                <div>个提问</div>
              </div>
              <div class="export-about-info">
                <div class="export-about-info-count">{{exportInfo.replyCount||0}}</div>
                <div>个回复</div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="export-reply">
        <div class="reply-header">
          <div class="reply-header1">专家回复问题</div>
          <!-- <div class="reply-header-factor">按发帖时间
            <i class="el-icon-arrow-down"></i>
          </div> -->
          <div class="reply-header-factor" >
            <span @click="sortHandle()"> 按发帖时间
              <i :class="sort==='desc'?'el-icon-arrow-down':'el-icon-arrow-up'"></i>
            </span>
          </div>
        </div>
        <!-- 类别 -->
        <el-row class="item-class-group" v-if="categoryList.length>0">
            <el-col class="item-class-name" :span="2">类别：</el-col>
            <el-col class="item-class-select" :span="19">
            <div v-for="(item, index) in categoryList" :key="index" @click="changeCategory(index)">
                <span :class="index === categoryIndex?'pageactive':''" >{{ item.fieldName }}</span>
            </div>
            </el-col>
            <el-col class="actions" :span="3">
              <el-tag type="info" v-show="categoryList.length>5">
                <span @click="e => show(0, e)">展开</span>
              </el-tag>
            </el-col>
        </el-row>
      </div>
    </div>
    <!-- 问题列表 -->
    <div class="posts-list">
      <div v-if="postsList&&postsList.length>0">
        <div class="posts" v-for="item in postsList" :key="item.id">
          <div class="posts-export">
            <img :src="item.expertAvatarUrl || BASE_URL + 'img/zwt.png'" :alt="item.expertName"/>
            <div class="posts-export-name">{{item.expertName}} 专家</div>
            <div class="posts-export-category overell" v-if="item.fileVideoTypeAttributeEntityList&&item.fileVideoTypeAttributeEntityList.length>0">
              <span v-for="it in item.fileVideoTypeAttributeEntityList" :key="it.id">{{it.typeAttributeValue}}</span>
            </div>
          </div>
          <div class="posts-info" @click="postsDetail(item.id)">
            <div class="posts-info-title overell">{{item.articleTitle}}</div>
            <div class="posts-info-content">{{item.articleContent}}</div>
            <div class="posts-info-author">
              <!-- 作者及相关详细 -->
              <img :alt="item.postsName" width="30px" height="30px" :src="item.userAvatarUrl || BASE_URL + 'img/zwt.png'" class="posts-info-author-img"/>
              <span>{{item.postsName}} &nbsp;上传&nbsp;|&nbsp;</span>
              <span>{{item.articleCommentCount}} &nbsp;个回复&nbsp;|&nbsp;</span>
              <span>{{item.articleViewCount}} &nbsp;次游览&nbsp;|&nbsp;</span>
              <span>{{item.createTime}}</span>
            </div>
            <div class="posts-reply" v-if="item.expertUserRepliyPostVo">
              <div class="posts-reply-title">专家回复：</div>
              <div class="posts-reply-content">{{item.expertUserRepliyPostVo.repliyPostContent}}</div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- 分页 -->
    <div class="pagination">
      <div class="doclist-pagination">
        <div class="doclist-lastpage" @click="jumpLastPage">上一页</div>
        <div class="doclist-omit">{{lastOmit}}</div>
        <ul>
          <li :class="item === currentPage?'pageactive':''" v-for="(item, index) in pageList" :key="index" @click="changePageTo(item)">{{item}}</li>
        </ul>
        <div class="doclist-omit">{{nextOmit}}</div>
        <div class="doclist-nextpage" @click="jumpNextPage">下一页</div>
        <div class="doclist-pagejump">共{{totalPage}}页，到第<input type="text" v-model.number="jumpTargetPage">页</div>
        <div class="doclist-jump" @click="jumpFarPage">确定</div>
      </div>
    </div>
  </div>
</template>
<script>
// import Cookies from 'js-cookie'
import { expertPutQuestionsTo } from '@/utils/eventTracking'
export default {
  data () {
    return {
      BASE_URL: process.env.BASE_URL,
      exportInfo: {},
      posts: {
        title: '',
        content: ''
      },
      postsList: [],
      categoryList: [],
      categoryIndex: -1,
      sort: 'desc',
      showMoreDetail: false,
      moreDetailStyle: 'height: 66px;',
      // 分页
      currentPage: 1, // 当前页
      totalPage: 4, // 总页数
      lastOmit: '',
      nextOmit: '',
      pageList: [1],
      jumpTargetPage: 1 // 跳转页
    }
  },
  computed: {
    exportId () {
      return this.$route.query.id
    },
    userId () {
      return this.$route.query.uId
    }
  },
  mounted () {
    if (this.exportId) {
      this.categoryIndex = -1
      this.getExportInfo()
      this.getDataList(1)
      this.getCategory()
    }
  },
  methods: {
    // 上一页
    jumpLastPage () {
      if (this.currentPage > 1) {
        var newCurrent = this.currentPage - 1
        this.changePageTo(newCurrent)
      } else {
        this.$message.info('这已经是第一页啦')
      }
    },
    //  下一页
    jumpNextPage () {
      if (this.currentPage < this.totalPage) {
        var newCurrent = this.currentPage + 1
        this.changePageTo(newCurrent)
      } else {
        this.$message.info('这已经是最后一页啦')
      }
    },
    //   第几页
    changePageTo (page) {
      this.getDataList(page)
    },
    //   确定跳转到哪页
    jumpFarPage () {
      if (this.jumpTargetPage >= 1 && this.jumpTargetPage <= this.totalPage) {
        this.changePageTo(this.jumpTargetPage)
      } else {
        this.$message.error('请输入正确的页码')
      }
    },
    // 获取专家信息
    getExportInfo () {
      this.$http.get(`${window.SITE_CONFIG['apiURL']}/front/kc/expertField/expertfieldrepliy/info/${this.exportId}`)
        .then(({ data }) => {
          if (data && data.code === 0) {
            this.exportInfo = data.data
            this.showMoreDetail = this.exportInfo.expertIntroduction && (this.exportInfo.expertIntroduction.length > 137)
          } else {
            this.exportInfo = {}
          }
        })
    },
    // 获取回复信息类目
    getCategory () {
      this.$http.get(`${window.SITE_CONFIG['apiURL']}/front/kc/expertField/expertfieldrepliy/findExpertReplyTypes/${this.userId}`)
        .then(({ data }) => {
          if (data && data.code === 0) {
            this.categoryList = data.data
          } else {
            this.categoryList = []
          }
        })
    },
    // 获取帖子列表
    getDataList (currentPage) {
      this.$http.post(`${window.SITE_CONFIG['apiURL']}/front/kc/expertField/expertfieldrepliy/viewReplyTypeList`, {
        typeId: this.categoryIndex === -1 ? '' : this.categoryList[this.categoryIndex].id,
        expertUserId: this.userId,
        page: currentPage,
        limit: 6,
        orderByParam: 't.create_time ' + this.sort
      })
        .then(({ data }) => {
          if (data && data.code === 0) {
            this.postsList = data.data.data || []
            this.totalPage = Math.ceil(data.data.count / 6)
          } else {
            this.postsList = []
            this.totalPage = 0
          }
          this.setPageTo(currentPage)
        })
    },
    setPageTo (page) {
      if (this.totalPage > 5) {
        if (page > 2 && page < this.totalPage - 1) {
          var newPageList = []
          for (let index = page - 2; index < page + 3; index++) {
            newPageList.push(index)
          }
          this.pageList = newPageList
          this.currentPage = page
          this.lastOmit = '...'
          this.nextOmit = '...'
        } else if (page <= 2) {
          this.pageList = [1, 2, 3, 4, 5]
          this.currentPage = page
          this.lastOmit = ''
          if (page >= this.totalPage - 2) {
            this.nextOmit = ''
          } else {
            this.nextOmit = '...'
          }
        } else {
          var newPageList2 = [this.totalPage - 4, this.totalPage - 3, this.totalPage - 2, this.totalPage - 1, this.totalPage]
          this.pageList = newPageList2
          this.currentPage = page
          this.lastOmit = '...'
          this.nextOmit = ''
        }
      } else {
        var newPageList5 = []
        for (let index = 1; index <= this.totalPage; index++) {
          newPageList5.push(index)
        }
        this.pageList = newPageList5
        this.lastOmit = ''
        this.nextOmit = ''
        this.currentPage = page
      }
    },
    // 切换类目
    changeCategory (index) {
      // console.log(index)
      this.categoryIndex = index
      this.getDataList(1)
    },
    // 帖子排序
    sortHandle () {
      this.sort = this.sort === 'desc' ? 'asc' : 'desc'
      this.getDataList(1)
    },
    cancle () {
      this.$router.go(-1)
    },
    routerHandleAskExport (id) {
      if (id) {
        expertPutQuestionsTo(this.exportInfo.name)
        this.$router.push({
          name: 'askToExpert',
          query: {
            id: id
          }
        })
      }
    },
    postsDetail (id) {
      if (id) {
        this.$router.push({
          name: 'postsDetail',
          query: {
            id: id
          }
        })
      }
    },
    showMoreDetailHandle () {
      this.showMoreDetail = !this.showMoreDetail
    }
  },
  watch: {
    exportId (newVal) {
      if (newVal) {
        this.getExportInfo()
      }
    },
    userId (newVal) {
      if (newVal) {
        this.getDataList(1)
        this.getCategory()
      }
    },
    showMoreDetail (newVal) {
      if (newVal === true) {
        this.moreDetailStyle = 'height: 66px;'
      } else {
        this.moreDetailStyle = 'height: auto;'
      }
    }
  }
}
</script>
<style scoped>
.ask-export{
  background-color: #fff;
  padding: 30px 30px;
  word-wrap: break-word;
  word-break: break-all;
}
.export-info{
    margin: 0;
    width: 100%;
    display: flex;
    padding-bottom: 30px;
    border-bottom: 1px solid #EEEEEE;
    margin-bottom: 40px;
}
.export-info-img{
    /* width: 160px; */
    height: 160px;
}
.export-info-img img {
    width: 160px;
    height: 160px;
}
.export-info-detail{
    padding-left: 20px;
    display: inline-block;
    width: 80%;
    position: relative;
}
.export-info-detail-name{
    text-align: left;
    line-height: 22px;
    font-size: 16px;
    color: #262626;
    height: 22px;
}
.export-info-detail-category{
  margin-top: 6px;
  margin-bottom: 8px;
  text-align: left;
  /* height: auto; */
  line-height: 20px;
  font-size: 14px;
  color: #262626;
}
.export-info-detail-category span {
  margin-right: 10px;
}
.export-info-detail-introduction{
  width: 100%;
  text-align: left;
  line-height: 22px;
  font-size: 14px;
  color: #666666;
  letter-spacing: 0.4px;
  overflow: hidden;
}
.export-info-opt{
    /* position: absolute;
    bottom: 0;
    left: 20px; */
    margin-top: 10px;
    height: 36px;
    line-height: 36px;
    width: 100%;
    display: flex;
    margin-bottom: 0px;
}
.export-info-opt-but{
    border: 1px solid #1D65A8;
    width: 100px;
    height: 32px;
    line-height: 32px;
    text-align: center;
    color: #1D65A8;
    letter-spacing: 0;
    cursor: pointer;
}
.export-info-opt-but:hover{
  background: #1D65A8;
  color: white;
}
.export-info-opt-label{
    text-align: right;
    margin-right: 19px;
    width: 100%;
}
.export-about-info{
    display: inline-block;
    margin-left: 40px;
    text-align: center;
    line-height: 20px;
    font-size: 14px;
    letter-spacing: 0;
    text-align: center;
}
.export-about-info-count{
    color: #1D65A8;
}
/* 专家回复*/
/* .export-reply{
    padding-top: 30px;
} */
.reply-header {
    width: 100%;
    text-align: left;
    line-height: 30px;
    font-size: 22px;
    color: #333333;
    height: 50px;
    display: flex;
    padding-bottom: 21px;
    border-bottom: 1px solid #EEE;
}
.reply-header1{
    width: 100%;
}
.reply-header-factor{
    width: 100%;
    text-align: right;
    line-height: 30px;
    font-size: 14px;
    color: #1D65A8;
    letter-spacing: 0.52px;
    height: 30px;
}
.posts-list{
  background-color: #fff;
  padding: 0 30px;
  border-top: 1px solid #EEE;
  word-wrap: break-word;
  word-break: break-all;
}
.posts{
    width: 100%;
    display: flex;
    padding-bottom: 21px;
    padding-top: 21px;
    border-bottom: 1px solid #eee;
}
.posts-export{
    /* width: 160px; */
    text-align: center;
}
.posts-export img{
    width: 160px;
    height: 160px;
}
.posts-export-name{
    margin-top: 22px;
    line-height: 22px;
    font-size: 16px;
    color: #262626;
    height: 22px;
}
.posts-export-category{
  /* width: 80%; */
  max-width: 160px;
  margin-top: 6px;
  text-align: center;
  /* height: 20px; */
  line-height: 20px;
  font-size: 14px;
  color: #666666;
}
.posts-export-category span{
    margin-right: 10px;
}
/* 帖子信息 */
.posts-info{
    padding-left: 20px;
    width: 100%;
    max-width: 680px;
    cursor: pointer;
}
.posts-info-title{
    text-align: left;
    line-height: 22px;
    font-size: 16px;
    color: #333333;
    letter-spacing: 0;
    height: 22px;
}
.posts-info-content{
    padding-top: 8px;
    text-align: left;
    line-height: 22px;
    font-size: 14px;
    color: #666666;
    letter-spacing: 0.5px;
    height: 74px;
    overflow:hidden;
    word-break:break-all;
    white-space:pre-wrap;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 3;
}
.posts-info-author{
    margin-top: 14px;
    padding-bottom: 12px;
    border-bottom: 1px solid #eee;
    /* margin-bottom: 20px; */
    font-size: 14px;
    width: 100%;
    height: 42px;
    line-height: 30px;
  }
  .posts-info-author-img{
    display: inline-block;
    border-radius: 15px;
    margin-right: 10px;
  }
  .posts-reply{
    padding-top:8px;
    text-align: left;
    font-size: 14px;
    color: #666666;
    letter-spacing: 0.4px;
  }
  .posts-reply-title{
    line-height: 20px;
    color: #E99436;
    height: 20px;
  }
  .posts-reply-content{
    padding-top:8px;
    line-height: 22px;
    height: 74px;
    overflow:hidden;
    word-break:break-all;
    white-space:pre-wrap;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 3;
  }
    /* 分页区域样式 */
  .pagination{
    background-color: #fff;
    padding-top: 30px;
    text-align: center;
  }
/* 分页区域样式结束 */
.reply-header-factor{
    width: 100%;
    text-align: right;
    line-height: 20px;
    font-size: 14px;
    color: #1D65A8;
    letter-spacing: 0.52px;
    height: 20px;
}
.reply-header-factor span{
  cursor: pointer;
}
.xkfkmore{
  width: 100%;
  height: 31px;
  line-height: 27px;
  text-align: center;
  color:#d4d4d4;
  font-size: 12px;
  background: url('/static/img/gengduo.png') no-repeat top center;
  margin-top: 20px;
  cursor: pointer;
}
p {
  margin: 0;
}
</style>
